module.exports = __webpack_public_path__ + "img/arrow_down_circle.29d8d936.svg";